import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["paragraph"]

  connect() {
    if(this.data.get('page') == "progress") {
      setInterval(() => {
        Rails.ajax({
          url: `/companies/${this.data.get("company-id")}/course_authoring/trainings/${this.data.get("training-id")}`,
          type: 'get',
          dataType: 'script'
        });
      }, 2000);
    }

    this.currentIndex = 0
    this.showParagraph(this.currentIndex)

    setInterval(() => {
      this.hideAllParagraphs()
      this.currentIndex = (this.currentIndex + 1) % this.paragraphTargets.length
      this.showParagraph(this.currentIndex)
    }, 6000)
  }

  hideAllParagraphs() {
    this.paragraphTargets.forEach(p => p.classList.add("d-none"))
  }

  showParagraph(index) {
    this.paragraphTargets[index]?.classList.remove("d-none")
  }
}
